/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["xh",[["AM","PM"]],u,[["C","M","Sb","Tht","Sin","Hl","Mg"],["Caw","Mvu","Lwesb","Tha","Sin","Hla","Mgq"],["Cawe","Mvulo","Lwesibini","Lwesithathu","Lwesine","Lwesihlanu","Mgqibelo"],["Caw","Mvu","Lwesb","Tha","Sin","Hla","Mgq"]],[["C","M","Sb","St","Sin","Hl","Mg"],["Caw","Mvu","Bin","Tha","Sin","Hla","Mgq"],["Cawe","Mvulo","Lwesibini","Lwesithathu","Lwesine","Lwesihlanu","Mgqibelo"],["Caw","Mvu","Lwesb","Tha","Sin","Hla","Mgq"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["Jan","Feb","Mat","Epr","Mey","Jun","Jul","Aga","Sept","Okt","Nov","Dis"],["Janyuwari","Februwari","Matshi","Epreli","Meyi","Juni","Julayi","Agasti","Septemba","Okthobha","Novemba","Disemba"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["Jan","Feb","Mat","Epr","Mey","Jun","Jul","Aga","Sep","Okt","Nov","Dis"],["Janyuwari","Februwari","Matshi","Epreli","Meyi","Juni","Julayi","Agasti","Septemba","Okthoba","Novemba","Disemba"]],[["BC","AD"]],0,[6,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE, MMMM d, y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],["."," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"ZAR","R","IRandi yaseMzantsi Afrika",{"CNH":["I-CNH"],"ZAR":["R"]},"ltr", plural];
